export const API_PATH_ApiDeviceMgmtDeviceDelete = '/services/devices-mgtm/apiDeviceMgmtDeviceDelete';
